import * as React from 'react'
import { PylonProvider as ReactUsePylonProvider } from './react-use-pylon'

type Props = {
  children: React.ReactNode
}

const PylonProvider = React.memo<Props>(({ children }) => {
  const appId = process.env.REACT_APP_PYLON_APP_ID ?? ''

  return <ReactUsePylonProvider appId={appId}>{children}</ReactUsePylonProvider>
})

PylonProvider.displayName = 'PylonProvider'
export default PylonProvider
